/* This is necessary in order to write better tests for SearchBarContainer. Once we want to
access instance methods and this component is wrapped in <Router>, the only way in Enzyme 2.x is
to export it without withRouter(). After migrating to Enzyme 3 we can avoid this */
import { withRouter } from 'react-router-dom';
import SearchBarContainer from './SearchBarContainer';

export default withRouter(SearchBarContainer);
